import React, { useState, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { Helmet } from 'react-helmet';
import Loader from '../components/Loader';
import GuideSidebar from '../components/GuideSidebar';

const ListingReview = () => {
    const [listings, setListings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1);
    const [activeIndex, setActiveIndex] = useState(null);

    useEffect(() => {
        const fetchListings = async () => {
            const hostData = getItemFromLocalStorage('hostProfile');
            let formData = new FormData();
            formData.append('token', hostData.host_access_token);

            try {
                const response = await axios({
                    method: 'post',
                    headers: {
                      'Content-Type': 'multipart/form-data'
                    },
                    url: `${params.baseURL}${params.endpoints.getMyCalendar}`,
                    data: formData
                });
            
                if (response.data.items && Array.isArray(response.data.items)) {
                    setListings(response.data.items);
                    setLoading(false);
                } else {
                    setError('An error occurred while fetching data.');
                }
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        };

        fetchListings();
    }, [page]);

    const faqs = [
        {
        question: "What is Lorem Ipsum?",
        answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
        },
        {
        question: "Where does it come from?",
        answer: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old."
        },
    ];
    
    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    if (loading) {
        return <Loader />;
    }

    if (error) {
        return <p>Error loading listings: {error.message}</p>;
    }

    return (
        <div>
            <Helmet>
                <title>Listing Ratings and Reviews</title>
                <meta name="description" content="" />
            </Helmet>

            <div className='row'>
                <div className='col-md-8'>
                    <div className='yl-header'>
                        <div style={{display:'flex', alignItems: 'center', gap: '10px'}}>
                            <img src={'/assets/img/banners/rating_review_banner.png'} className='img-fluid' />
                        </div>
                    </div>
                    {listings.length > 0 ? (
                        <div className='row'>
                            {listings.map((listing, index) => (
                                <a href={`/ratings/${listing.stay_listing_id}`} className='col-md-6 lb mb-3' key={listing.stay_listing_id}>
                                    <div className='mylst-bx' style={{border:'0'}}>
                                        <div className='lcibox' style={{ marginBottom: '1rem' }}> 
                                            <div className='acc-box'>
                                                <div className="apimgcibox">
                                                    <div className='image-wrapper lcibox w-100'>
                                                        <div className='ac-cover-image'>
                                                            <img
                                                                className="ciso ap-ciso w-100"
                                                                style={{height:'200px'}}
                                                                src={listing.cover_photo ? listing.cover_photo : '/assets/img/default_listing.jpg'}
                                                                alt={listing.listing_title ? listing.listing_title : 'Untitled Listing'}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='pltxt-box'>       
                                                    <div className='cat-pointer'>
                                                        <img src={listing.property_title_icon_image} alt='' className='img-fluid pointer-icon' style={{boxShadow:'none'}} />
                                                        <div className='wspl-ta-section'>
                                                            <span className='wspl-title-box'>{listing.listing_title || 'Unknown Title'}</span>
                                                            <span className='wspl-add-box'>{listing.property_address}</span>
                                                        </div>
                                                    </div>
                                                    <div className='mrrsbox'>
                                                        <div className='mrrspn' style={{width:'48%'}}>
                                                            <span className='mllrvc'>{listing.overall_rating || '0.0'}</span>
                                                            <span style={{marginTop:'-2px'}}>
                                                            {Array.from({ length: 5 }).map((_, index) => {
                                                                const rating = listing.overall_rating;
                                                                const fullStars = Math.floor(rating);
                                                                const hasHalfStar = rating - fullStars >= 0.25 && rating - fullStars < 0.75;

                                                                if (index < fullStars) {
                                                                    return <i key={index} className="fas fa-star"></i>;
                                                                } else if (index === fullStars && hasHalfStar) {
                                                                    return <i key={index} className="fas fa-star-half-alt"></i>;
                                                                } else {
                                                                    return <i key={index} className="far fa-star"></i>;
                                                                }
                                                            })}
                                                            </span>
                                                        </div>
                                                        <span className='mrline'></span>
                                                        <span className='mllrvc' style={{width:'48%', textAlign:'right'}}>{listing.rating_review_text}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            ))}
                        </div>
                    ) : (
                        <p>No listings found</p>
                    )}
                </div>

                <div className='col-md-4 p-0'>
                    <GuideSidebar slug="my-ratings" />
                </div>
            </div>

        </div>
    );
};

export default ListingReview;
